import { plainToInstance } from 'class-transformer'
import { ISiteBoxDocumentImagesData } from '@core/entities/SiteBoxDocumentImagesData'
import { Entity } from '../entity'
import { ImageDataPixelScale } from './types'

export class SiteBoxDocumentImagesData extends Entity<ISiteBoxDocumentImagesData> {
  imageKey: string
  getUrl: string
  downloadUrl: string
  imageName: string
  imageWidthInPixels: number
  imageHeightInPixels: number
  pixelScale: ImageDataPixelScale

  public static new(payload: ISiteBoxDocumentImagesData) {
    const entity = plainToInstance(SiteBoxDocumentImagesData, payload)

    return entity
  }
}
